import { getAppsyncUrl } from "../authenticate";
import {getUserPool} from "../pools/pools";
import { getAuth } from '../../contexts/authStore';

// Browser-safe SHA-256 hash helper (returns hex)
export async function hashString(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function putSchedule(userId: string, scheduleId: string, name: string, color: string, link: string, employees: string[], favorite: boolean,
  allowSwapWithoutApproval: boolean, allowPickUpWithoutApproval: boolean, viewOtherStaff: boolean, activeScheduleFrequency: string, lastActiveScheduleDate: string,
  availabilityScheduleRequiredTime: number, activeScheduleDate: string, lastSubmitted: string
) {
  if (getUserPool()!.getCurrentUser()) {
    const hashScheduleId = await hashString(scheduleId);
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `mutation Mutation {
            putSchedule(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)}, name: ${JSON.stringify(name)}, color: ${JSON.stringify(color)}, link: ${link ? JSON.stringify(link) : '""'}, hashScheduleId: ${JSON.stringify(hashScheduleId)}, employees: ${employees ? JSON.stringify(employees) : JSON.stringify([])}
            ${favorite ? ", favorite: " + JSON.stringify(favorite) : ''}${allowSwapWithoutApproval ? ", allowSwapWithoutApproval: " + JSON.stringify(allowSwapWithoutApproval) : ''}${allowPickUpWithoutApproval ? ", allowPickUpWithoutApproval: " + JSON.stringify(allowPickUpWithoutApproval) : ''}${viewOtherStaff ? ", viewOtherStaff: " + JSON.stringify(viewOtherStaff) : ''}
            ${activeScheduleFrequency ? ", activeScheduleFrequency: " + JSON.stringify(activeScheduleFrequency) : ''}${lastActiveScheduleDate ? ", lastActiveScheduleDate: " + JSON.stringify(lastActiveScheduleDate) : ''}${availabilityScheduleRequiredTime ? ", availabilityScheduleRequiredTime: " + JSON.stringify(availabilityScheduleRequiredTime) : ''}
            ${activeScheduleDate ? ", activeScheduleDate: " + JSON.stringify(activeScheduleDate) : ''}${lastSubmitted ? ", lastSubmitted: " + JSON.stringify(lastSubmitted) : ''})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.putSchedule)
      })
    })
  }
}

export async function putSchedulePublic(userId: string, scheduleId: string, name: string, link: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `mutation Mutation {
            putSchedulePublic(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)}, name: ${JSON.stringify(name)}, link: ${link ? JSON.stringify(link) : '""'})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.putSchedulePublic)
      })
    })
  }
}

export async function submitSchedule(userId: string, scheduleId: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `mutation Mutation {
            submitSchedule(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.submitSchedule)
      })
    })
  }
}

export async function putScheduleUser(userId: string, scheduleOwnerId: string, name: string, accessLevel?: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `mutation Mutation {
            putScheduleUser(userId: ${JSON.stringify(userId)}, scheduleOwnerId: ${JSON.stringify(scheduleOwnerId)}
            , name: ${JSON.stringify(name)}${accessLevel ? ", accessLevel: " + JSON.stringify(accessLevel) : ''})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.putScheduleUser)
      })
    })
  }
}

export async function getSchedules(userId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getSchedules(userId: ${JSON.stringify(userId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getSchedules)
            })
        })
    }
}

export async function getSchedule(userId: string, scheduleId: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `query Query {
            getSchedule(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.getSchedule)
      })
    })
  }
}

export async function getScheduleUser(userId: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `query Query {
            getScheduleUser(userId: ${JSON.stringify(userId)})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.getScheduleUser)
      })
    })
  }
}

export async function deleteSchedule(userId: string, scheduleId: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                deleteSchedule(userId: ${JSON.stringify(userId)}, scheduleId: ${JSON.stringify(scheduleId)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.deleteSchedule)
            })
        })
    }
}

export async function deleteScheduleUser(userId: string, scheduleOwnerId: string) {
  if (getUserPool()!.getCurrentUser()) {
    const token = getAuth().idToken!;
    return await fetch(
      getAppsyncUrl(),
      {
        method: "post",
        headers: {
          "Authorization": token
        },
        body: JSON.stringify({
          query: `mutation Mutation {
            deleteScheduleUser(userId: ${JSON.stringify(userId)}, scheduleOwnerId: ${JSON.stringify(scheduleOwnerId)})
          }`
        }),
        credentials: "omit",
      }
    ).then(async (response) => {
      return await response.json().then(async (response) => {
        return JSON.parse(response?.data?.deleteScheduleUser)
      })
    })
  }
}
